<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="600"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :rules="rules"
      :model="monitoring_data"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Monitoring Periods :</p>
        </el-alert>
        <el-row :gutter="20">
          <!-- <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="start_date"
              label="Start Date: "
            >
              <el-date-picker
                v-model="monitoring_data.start_date"
                type="date"
                format="DD/MM/YYYY"
                value-format="YYYY-MM-DD"
                class="dtp-customer w-100"
                prefix-icon=""
              />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="end_date"
              label="End Date: "
            >
              <el-date-picker
                v-model="monitoring_data.end_date"
                type="date"
                format="DD/MM/YYYY"
                value-format="YYYY-MM-DD"
                class="dtp-customer w-100"
                prefix-icon=""
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="start_date"
              label="Start Date: "
            >
              <el-date-picker
                v-model="monitoring_data.start_date"
                type="datetime"
                format="DD/MM/YYYY HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                date-format="DD/MM/YYYY"
                time-format="HH:mm:ss"
                class="dtp-customer w-100"
                prefix-icon=""
              />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="end_date"
              label="End Date: "
            >
              <el-date-picker
                v-model="monitoring_data.end_date"
                type="datetime"
                format="DD/MM/YYYY HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                date-format="DD/MM/YYYY"
                time-format="HH:mm:ss"
                class="dtp-customer w-100"
                prefix-icon=""
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <!-- <el-form-item class="label-style" prop="status" label="Status: ">
              <el-input v-model="monitoring_data.status" />
            </el-form-item> -->
            <el-select
              v-model="monitoring_data.status"
              placeholder="Select period status ..."
              class="w-100"
              @change="handleCommand(monitoring_data.status)"
            >
              <el-option
                v-for="item in status_list"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
                <span style="float: left">{{ item.title }}</span>
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <!-- <el-form-item class="label-style" prop="status" label="Status: ">
              <el-input v-model="monitoring_data.status" />
            </el-form-item> -->
            <!-- <el-select
              v-model="monitoring_data.status"
              placeholder="Select"
              class="w-100"
            >
              <el-option
                v-for="item in status_list"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
                <span style="float: left">{{ item.title }}</span>
              </el-option>
            </el-select> -->
            <el-form-item
              class="label-style"
              prop="name"
              >
            <el-input
              v-model="monitoring_data.name"
              placeholder="Type to name the period ..."
              :prefix-icon="Search"
              class="w-100"
              :class="$vuetify.display.width >= 1200 ? 'width-400' : ''"
                  />
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>
    <!-- </el-row> -->
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="confirm"
          color="#234B49"
          :disabled="!allowSubmitProp"
        >
          <i class="fa fa-check me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Confirm</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
// import "animate.css";
import UserService from "../../services/user.service";

// import moment from "moment";
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return rawProps;
      },
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },

    allowSubmitProp: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: this.open_modal,
      userDataList: [],
      rules: {
        start_date: [
          {
            type: "datetime",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isValidDate(value)) {
                  reject("time must be valid date"); // reject with error message
                } else {
                  resolve();
                }
              });
            },
          },
          {
            required: true,
            message: "Please enter start date.",
            trigger: "blur",
          },
        ],
        end_date: [
          {
            type: "datetime",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isValidDate(value)) {
                  reject("time must be valid date"); // reject with error message
                } else {
                  resolve();
                }
              });
            },
          },
          {
            required: true,
            message: "Please enter end date.",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "Please select a status",
            trigger: "change",
          },
        ],
      },
      monitoring_data: {
        id: 0,
        status: "",
        start_date: null,
        end_date: null,
        name: "",
      },
      status_list: [
        { id: "current", title: "Pre-Audit (Current MP)" },
        { id: "under_audit", title: "Under Audit" },
        { id: "issue_requested", title: "Issue Requested" },
        { id: "revision_under_audit", title: "Revision Under Audit" },
        { id: "revision_issue_requested", title: "Revision Issue Requested" },
        { id: "issued", title: "Issued" },
      ],
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      if (newVal == true) {
        this.monitoring_data = JSON.parse(this.data_modal);
      }
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
      },
      deep: true,
    },
  },
  methods: {
    handleCommand(command) {
      if (command == "current") {
        this.$emit("checkCurrentMP");
      }
      else if (command == "revision_under_audit") {
        this.$emit("checkRevisionUnderAuditMP");
      }
      else if (command == "revision_issue_requested") {
        this.$emit("checkRevisionIssueRequestedMP");
      }
      else {
        this.$emit("bypassAllowSubmitCheck");
      }
    },

    isValidDate(dateString) {
      const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (dateRegex.test(dateString)) {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    isNewUser() {
      if (this.monitoring_data.id == 0) return true;
      else return false;
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
    async confirm() {
      await this.$refs["ruleFormRef"].validate((valid, fields) => {
        if (valid) {
          UserService.SetMonitoringPeriod(this.monitoring_data)
            .then(
              (response) => {
                this.$emit("confirm_modal", response.data.monitoring_periods);
              },
              (error) => {
                this.loading = false;
                console.log(error);
                if (error.response.status == 401) {
                  this.$router.push({
                    path: "/",
                  });
                }
              }
            )
            .catch((error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            })
            .finally(() => {
              this.loading = false
              this.$emit("handleReload");
            });
        } else {
          console.log("error submit!", fields);
        }
      });
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}
.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
